<div nz-row class="location-intro-image"></div>
<div style="height: 150px;"></div>
<div class="location-message" style="height: 180px;">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px; font-family: 'Noto Sans',sans-serif;">
      서울 본사<br />
    </div>
    <div style="font-weight: normal; font-size: 20px; font-family: 'Noto Sans',sans-serif;">
      <p>
        서울시 성동구 성수일로 4길 25, 1508호 (서울숲코오롱디지털 1차)<br/>
        Tel. 02-2115-8815 Fax. 02-2115-8818<br/>
      </p>
    </div>
  </div>
</div>
<div class="location-map">
  <iframe width="600" height="450" style="border:0" loading="lazy" allowfullscreen src="https://www.google.com/maps/embed/v1/place?q=%EC%84%9C%EC%9A%B8%EC%8B%9C%20%EC%84%B1%EB%8F%99%EA%B5%AC%20%EC%84%B1%EC%88%98%EC%9D%BC%EB%A1%9C%204%EA%B8%B8%2025%2C%201508%ED%98%B8&key=AIzaSyBlTaT2VLyyMcUfoWK4VbbXhUGdWrSPY8I"></iframe>
  <!-- <img style="width: 1000px; height: 470px;" src="https://maps.googleapis.com/maps/api/staticmap?center=37.542511,127.052046&zoom=15&size=800x400&markers=color:blue%7Clabel:A%7C37.542511,127.052046&key=AIzaSyBlTaT2VLyyMcUfoWK4VbbXhUGdWrSPY8I" /> -->
</div>
<div class="location-message">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      대중교통 이동시<br />
    </div>
    <div style="font-weight: normal; font-size: 16px; font-family: 'Noto Sans',sans-serif; padding-bottom: 30px;">
      <p>
        성수역(2호선) 4번 출구 하차 도보 7분<br/>
      </p>
    </div>
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      차량 이용시<br />
    </div>
    <div style="font-weight: normal; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      <p>
        강변북로 구리방면 : 반포대교 지나서 한남동,용비교 램프 진입 > 용비교 >
                          성수대교 북단 사거리에서 직진 > 성수현대그린아파트 – 성진학교 사이 골목길로 좌회전 진입
      </p>
    </div>
    <div style="font-weight: normal; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      <p>
        강변북로 일산방면 : 영동대교 지나서 성동교,서울숲 램프 진입 > 성수대교 북단 사거리에서 우회전 >
                          성수현대그린아파트-성진학교 사이 골목길로 좌회전 진입
      </p>
    </div>
  </div>
</div>
<div style="height: 150px;"></div>
<div class="location-message" style="height: 180px;">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px; font-family: 'Noto Sans',sans-serif;">
      천안 공장<br />
    </div>
    <div style="font-weight: normal; font-size: 20px; font-family: 'Noto Sans',sans-serif;">
      <p>
        충남 천안시 서북구 입장면 흑암길 50<br/>
        Tel. 041-582-2214 Fax. 041-588-2215<br/>
      </p>
    </div>
  </div>
</div>
<div class="location-map">
  <!-- <img style="width: 1000px; height: 470px;" src="https://maps.googleapis.com/maps/api/staticmap?center=36.933587,127.183702&zoom=15&size=800x400&markers=color:blue%7Clabel:A%7C36.933587,127.183702&key=AIzaSyBlTaT2VLyyMcUfoWK4VbbXhUGdWrSPY8I" /> -->
  <iframe width="600" height="450" style="border:0" loading="lazy" allowfullscreen src="https://www.google.com/maps/embed/v1/place?q=%EC%B6%A9%EB%82%A8%20%EC%B2%9C%EC%95%88%EC%8B%9C%20%EC%84%9C%EB%B6%81%EA%B5%AC%20%EC%9E%85%EC%9E%A5%EB%A9%B4%20%ED%9D%91%EC%95%94%EA%B8%B8%2050&key=AIzaSyBlTaT2VLyyMcUfoWK4VbbXhUGdWrSPY8I"></iframe>
</div>
<div class="location-message">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      안성톨게이트에서 진입하는 경우<br />
    </div>
    <div style="font-weight: normal; font-size: 16px; font-family: 'Noto Sans',sans-serif; padding-bottom: 30px;">
      <p>
        안성IC에서 평택방면으로 좌회전하여 10분가량 직진한 뒤, S-oil주유소에서 좌회전하여 15분 가량 직진<br/>
        계양공구에 도착하기 바로 전(무인카메라)에 우회전하여 5분가량 직진하면 바이오스페이스 천안공장 옆길<br/>
      </p>
    </div>
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      천안톨게이트에서 진입하는 경우<br />
    </div>
    <div style="font-weight: normal; font-size: 16px; font-family: 'Noto Sans',sans-serif;">
      <p>
        천안IC에서 우회전하여 30분 가량 직진, 34번 국도(입장사거리)와 만나는 지점에서 성환 방면으로 좌회전하여 5분 가량 직진<br/>
        경부고속도로 밑의 굴다리를 지난 후 바로 우회전하거나 혹은, 굴다리를 지난 후 유턴하여 굴다리 바로 앞에서<br/>
        우회전하여 좌회전 한 후 10분가량 직진하면 바이오스페이스 천안공장 옆길<br/>
      </p>
    </div>
  </div>
</div>
<div style="height: 150px;"></div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
